import { Priorities, SearchFields, Statuses, StatusesInfo } from '~/utils/types/job';

export const DEFAULT_PAGE = 1;
export const DEFAULT_SORT_DIRECTION = 'ASC';
export const DEFAULT_ORDER_BY_KEY = 'projectName';

export const CREATE_JOB_FILE = 'createJobFile';
export const CREATE_CUSTOMER_FILE = 'createCustomerFile';
export const CREATE_ESTIMATE_FILE = 'createEstimateFile';

export const FILE_ITEM_FOR_TASK = 'fileItemForTask';
export const FILE_ITEM_FOR_ESTIMATE = 'fileItemForEstimate';
export const FILE_ITEM_FOR_ESTIMATE_TEMPLATE = 'fileItemForEstimateTemplate';
export const FILE_ITEM_FOR_CUSTOMER = 'fileItemForCustomer';

export const TASKS_JOB_DETAILS: Array<{ id: string; title: string }> = [
  { id: 'new', title: 'new' },
  { id: 'contacted', title: 'contacted' },
  { id: 'assessment_scheduled', title: 'assessment_scheduled' },
  { id: 'inspected', title: 'inspected' },
  { id: 'estimate_sent', title: 'estimate_sent' },
  { id: '1st_follow_up', title: '1st_follow_up' },
  { id: '2nd_follow_up', title: '2nd_follow_up' },
  { id: 'ready_for_production', title: 'ready_for_production' },
  { id: 'in_production', title: 'in_production' },
  { id: 'work_completed', title: 'work_completed' },
  { id: 'invoiced', title: 'invoiced' },
  { id: 'closed', title: 'closed' },
  { id: 'lost', title: 'lost' },
  { id: 'on_hold', title: 'on_hold' },
  { id: 'collections', title: 'collections' },
];

export const TASKS_JOB_BOARD: Array<{ id: string; title: string }> = [
  { id: 'new', title: 'new' },
  { id: 'contacted', title: 'contacted' },
  { id: 'assessment_scheduled', title: 'assessment_scheduled' },
  { id: 'inspected', title: 'inspected' },
  { id: 'estimate_sent', title: 'estimate_sent' },
  { id: '1st_follow_up', title: '1st_follow_up' },
  { id: '2nd_follow_up', title: '2nd_follow_up' },
  { id: 'ready_for_production', title: 'ready_for_production' },
  { id: 'in_production', title: 'in_production' },
  { id: 'work_completed', title: 'work_completed' },
  { id: 'invoiced', title: 'invoiced' },
  { id: 'closed', title: 'closed' },
  { id: 'lost', title: 'lost' },
  { id: 'on_hold', title: 'on_hold' },
  { id: 'collections', title: 'collections' },
];
export const CHOOSE_TIME_LIST = [15, 30, 45, 60, 90];

export const SELECTION_TYPES = {
  SCHEDULE: 'schedule',
};

export const PRIORITIES: Priorities = ['urgent', 'high', 'normal', 'low'];

export const STATUSES: Statuses = ['progress', 'hold', 'completed'];
export const STATUS_DEFAULT = 'progress';

export const STATUSES_INFO: StatusesInfo = [
  'new',
  'contacted',
  'assessment_scheduled',
  'inspected',
  'estimate_sent',
  '1st_follow_up',
  '2nd_follow_up',
  'ready_for_production',
  'in_production',
  'work_completed',
  'invoiced',
  'closed',
  'lost',
  'on_hold',
  'collections',
];
export const STATUS_DEFAULT_INFO = 'new';

export const SEARCH_FIELDS: SearchFields = ['name', 'createdBy', 'status', 'deadline'];

export const ROOM_SKETCHES: Array<string> = ['hard_surface', 'carpet', 'heavy', 'weight'];

export const JOB_LIST = 'list';

export const JOB_BOARD = 'board';

export const JOB = 'jobs';

export const CUSTOMERS = 'customers';

export const ALL_FILES = 'All Files';
